<template>
<div>
    <section class="hero is-danger">
        <div class="hero-body">
            <div class="container">
                <h1 class="title">
                    Access denied
                </h1>
                <h2 class="subtitle">{{ error_message }}</h2>
            </div>
        </div>
    </section>
    <tile-box class="buttons">
        <p class="title is-4">Try to:</p>
        <router-link
            tag="li"
            to="/oauth/project-selector"
            exact
            class="button is-primary"
        >
            <span class="bx side-menu-item-icon">
                <fa icon="building" fixed-width></fa>
            </span>
            <span class="side-menu-item-text">Change Project</span>
        </router-link>

        <router-link class="button is-danger oauth-logout-button" to="/oauth/logout">
            Logout <fa icon="sign-out-alt" fixed-width></fa>
        </router-link>

    </tile-box>
</div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'

import TileBox from '../../components/UI/TileBox.vue';

export default {
    name: 'NoAccess',
    components: { TileBox },
    computed: {
        error_message() {
            return this.$store.getters['error_message'];
        }
    },
    beforeRouteEnter(to, from, next) {
        next(//vm => {
            //vm.$oauthInitSession();
            //}
        );
    }
};
</script>
